export var OrganizationIdentifierScheme;
(function (OrganizationIdentifierScheme) {
    OrganizationIdentifierScheme["DK_CVR"] = "DK:CVR";
    OrganizationIdentifierScheme["GLN"] = "GLN";
})(OrganizationIdentifierScheme || (OrganizationIdentifierScheme = {}));
export var EInvoiceType;
(function (EInvoiceType) {
    EInvoiceType["Invoice"] = "INVOICE";
    EInvoiceType["Reminder"] = "REMINDER";
    EInvoiceType["Creditnote"] = "CREDITNOTE";
})(EInvoiceType || (EInvoiceType = {}));
//# sourceMappingURL=index.js.map